import { render, staticRenderFns } from "./PurchaseDocumentEdit.vue?vue&type=template&id=46ef27ac&scoped=true"
import script from "./PurchaseDocumentEdit.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocumentEdit.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseDocumentEdit.vue?vue&type=style&index=0&id=46ef27ac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef27ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46ef27ac')) {
      api.createRecord('46ef27ac', component.options)
    } else {
      api.reload('46ef27ac', component.options)
    }
    module.hot.accept("./PurchaseDocumentEdit.vue?vue&type=template&id=46ef27ac&scoped=true", function () {
      api.rerender('46ef27ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/PurchaseDocumentEdit.vue"
export default component.exports